import React from 'react';
import './BanketteCatering.css';

const BanketteCatering = ({ settings = {} }) => {
  console.log('BanketteCatering component loaded with settings:', settings);
  
  const {
    hero_title = 'Bankette & Catering',
    hero_subtitle = 'Feiern Sie unvergessliche Momente im Damas',
    hero_description = 'Im Herzen von Zürich erwartet Sie ein Ort voller Geschmack, Wärme und orientalischer Eleganz.\nOb Familienfeier, Geburtstag, Jubiläum, Hochzeit oder Business-Event – im Damas schaffen wir den perfekten Rahmen für Ihre besonderen Anlässe.',
    hero_background_image = '',
    
    // Platz & Atmosphäre section
    space_title = 'Platz & Atmosphäre',
    space_icon = '🍽️',
    space_content = '• Innenbereich: bis zu 70 Gäste\n• Terrasse: bis zu 30 Plätze, im Sommer lebendig – im Winter mit offenem Feuer für eine warme Stimmung\n\nEin Ort, an dem man sich zuhause fühlt – mit dem Duft orientalischer Gewürze, sanfter Musik und ehrlicher Gastfreundschaft.',
    space_image = '',
    
    // Kulinarische Erlebnisse section
    culinary_title = 'Kulinarische Erlebnisse',
    culinary_icon = '🧑‍🍳',
    culinary_content = 'Erleben Sie die feinen Aromen der syrischen und orientalischen Küche, zubereitet mit Liebe, Leidenschaft und überlieferten Familienrezepten.\nGemeinsam mit unserem Chefkoch gestalten wir ein individuelles Menü, das Ihre Wünsche und Ideen widerspiegelt – von traditionellen Spezialitäten bis hin zu modernen Kreationen.',
    culinary_image = '',
    
    // Individuell section
    personal_title = 'Individuell. Persönlich. Herzlich.',
    personal_icon = '💫',
    personal_content = 'Wir begleiten Sie bei jedem Schritt – von der Menügestaltung bis zur Dekoration.\nOb mit musikalischer Begleitung oder orientalischem Tanz, wir sorgen dafür, dass Ihr Fest unvergesslich wird.\n\nAuch außerhalb unseres Hauses bringen wir den Geschmack von Damas zu Ihnen – mit unserem Catering-Service, der Qualität und Atmosphäre direkt zu Ihrem Event liefert.',
    personal_image = '',
    
    // Promise section
    promise_title = 'Unser Versprechen',
    promise_icon = '❤️',
    promise_content = 'Wir hören zu, wir beraten, und wir möchten eines:\nIhre Erwartungen übertreffen.\nMit Geschmack, Stil und echter syrischer Gastfreundschaft.',
    promise_image = '',
    
    // Gallery
    gallery_images = [],
    
    // Styling
    background_color = '#ffffff',
    text_color = '#333333',
    accent_color = '#4A90E2',
    categories_background_color = '#f8f9ff'
  } = settings;

  const formatContent = (content) => {
    return content.split('\n').map((line, index) => (
      <p key={index} className="bankette-catering__text">
        {line}
      </p>
    ));
  };

  const renderImagePlaceholder = (image, altText) => {
    if (image) {
      return (
        <img 
          src={image} 
          alt={altText}
          className="bankette-catering__image"
        />
      );
    }
    return (
      <div className="bankette-catering__image-placeholder">
        <div className="bankette-catering__placeholder-icon">🖼️</div>
        <p className="bankette-catering__placeholder-text">Bild hochladen</p>
      </div>
    );
  };

  return (
    <div className="bankette-catering" style={{ backgroundColor: background_color, color: text_color, minHeight: '100vh', padding: '2rem' }}>
      <h1 style={{ fontSize: '3rem', color: '#4A90E2', textAlign: 'center', marginBottom: '2rem' }}>
        TEST: Bankette Catering Page Loaded!
      </h1>
      <div style={{ background: '#f0f0f0', padding: '2rem', marginBottom: '2rem', borderRadius: '10px' }}>
        <h2>{hero_title}</h2>
        <p>{hero_subtitle}</p>
        <p>Settings object: {JSON.stringify(settings, null, 2)}</p>
      </div>
      
      {/* Hero Section */}
      <section className="bankette-catering__hero">
        <div 
          className="bankette-catering__hero-bg"
          style={{
            backgroundImage: hero_background_image ? `url(${hero_background_image})` : 'linear-gradient(135deg, #4A90E2 0%, #87ceeb 100%)'
          }}
        />
        <div className="bankette-catering__hero-content">
          <div className="bankette-catering__container">
            <h1 className="bankette-catering__hero-title">{hero_title}</h1>
            <div className="bankette-catering__divider">⸻</div>
            <h2 className="bankette-catering__hero-subtitle">
              <span className="bankette-catering__emoji">🌿</span>
              {hero_subtitle}
            </h2>
            <div className="bankette-catering__hero-description">
              {formatContent(hero_description)}
            </div>
          </div>
        </div>
      </section>

      {/* Content Sections */}
      <div className="bankette-catering__container">
          {/* UNSERE MENÜKATEGORIEN block with editable background */}
          <section
            className="bankette-catering__categories"
            style={{ backgroundColor: categories_background_color, padding: '2rem', borderRadius: '1rem', marginBottom: '2rem' }}
          >
            <h2 style={{ margin: 0, fontSize: '2rem', fontWeight: 700 }}>UNSERE MENÜKATEGORIEN</h2>
            {/* ...existing code for categories... */}
          </section>
        
        {/* Platz & Atmosphäre */}
        <section className="bankette-catering__section">
          <div className="bankette-catering__section-content">
            <div className="bankette-catering__text-content">
              <div className="bankette-catering__divider">⸻</div>
              <h3 className="bankette-catering__section-title" style={{ color: accent_color }}>
                <span className="bankette-catering__section-icon">{space_icon}</span>
                {space_title}
              </h3>
              <div className="bankette-catering__section-text">
                {formatContent(space_content)}
              </div>
            </div>
            <div className="bankette-catering__image-content">
              {renderImagePlaceholder(space_image, 'Restaurant Atmosphäre')}
            </div>
          </div>
        </section>

        {/* Kulinarische Erlebnisse */}
        <section className="bankette-catering__section bankette-catering__section--reverse">
          <div className="bankette-catering__section-content">
            <div className="bankette-catering__image-content">
              {renderImagePlaceholder(culinary_image, 'Kulinarische Erlebnisse')}
            </div>
            <div className="bankette-catering__text-content">
              <div className="bankette-catering__divider">⸻</div>
              <h3 className="bankette-catering__section-title" style={{ color: accent_color }}>
                <span className="bankette-catering__section-icon">{culinary_icon}</span>
                {culinary_title}
              </h3>
              <div className="bankette-catering__section-text">
                {formatContent(culinary_content)}
              </div>
            </div>
          </div>
        </section>

        {/* Individuell */}
        <section className="bankette-catering__section">
          <div className="bankette-catering__section-content">
            <div className="bankette-catering__text-content">
              <div className="bankette-catering__divider">⸻</div>
              <h3 className="bankette-catering__section-title" style={{ color: accent_color }}>
                <span className="bankette-catering__section-icon">{personal_icon}</span>
                {personal_title}
              </h3>
              <div className="bankette-catering__section-text">
                {formatContent(personal_content)}
              </div>
            </div>
            <div className="bankette-catering__image-content">
              {renderImagePlaceholder(personal_image, 'Individueller Service')}
            </div>
          </div>
        </section>

        {/* Gallery Section */}
        {gallery_images.length > 0 && (
          <section className="bankette-catering__gallery">
            <div className="bankette-catering__divider">⸻</div>
            <h3 className="bankette-catering__section-title" style={{ color: accent_color }}>
              <span className="bankette-catering__section-icon">📸</span>
              Impressionen
            </h3>
            <div className="bankette-catering__gallery-grid">
              {gallery_images.map((image, index) => (
                <div key={index} className="bankette-catering__gallery-item">
                  <img src={image} alt={`Gallery ${index + 1}`} />
                </div>
              ))}
            </div>
          </section>
        )}

        {/* Promise Section */}
        <section className="bankette-catering__promise">
          <div className="bankette-catering__divider">⸻</div>
          <div className="bankette-catering__promise-content">
            <h3 className="bankette-catering__section-title" style={{ color: accent_color }}>
              <span className="bankette-catering__section-icon">{promise_icon}</span>
              {promise_title}
            </h3>
            <div className="bankette-catering__promise-text">
              {formatContent(promise_content)}
            </div>
            <div className="bankette-catering__promise-image">
              {renderImagePlaceholder(promise_image, 'Unser Versprechen')}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default BanketteCatering;